import React from 'react';
import { List, Loader } from 'semantic-ui-react';
import { connect } from 'react-redux';
import { states } from '@/constants/lifecycle';
import { vocabularyCodes } from '@/vocabularies/constants';
import findResult from '@/utils/resultsHelper';
import availableRoleActions from '../helper';
import { roleManagementAccessControl } from '../../helper';
import EditRoleActionButton from '../components/EditRoleActionButton';
import RoleActionsLabelGroup from '../components/RoleActionsLabelGroup';
import { showRoleActions } from '../actions';

const RoleActionsContent = ({
  category,
  code,
  allowEdit,
  disabled,
  loading,
  readStatus,
  roleActions,
  showDialog,
}) => (
  <List.Content>
    {loading && <Loader active inline size="tiny" />}
    {!loading && roleActions.length > 0 && (<RoleActionsLabelGroup roleActions={roleActions} disabled={disabled} />)}
    {!loading && roleActions.length === 0 && (
    <EditRoleActionButton
      disabled={disabled || !allowEdit}
      onClick={() => showDialog(code, category, roleActions, readStatus)}
    />
    )}
  </List.Content>
);

const mapStateToProps = ({
  auth: { role: { permissions } },
  roles: { roles },
  vocabularies: { vocabularies: { all: { results } } },
}, { category, code }) => {
  const vocabularyRoleActions = results.find((v) => v.code === vocabularyCodes.ROLE_ACTIONS)?.roleActions || [];
  const role = findResult(roles, category, code) || { roleActions: { readStatus: states.NONE, items: [] } };
  const { roleActions } = role;

  return {
    allowEdit: roleManagementAccessControl({ permissions }, role).allowRoleActionsEdit,
    disabled: role.isEditing || roleActions.readStatus !== states.SUCCESS,
    loading: roleActions.readStatus === states.PENDING,
    readStatus: roleActions.readStatus,
    roleActions: availableRoleActions(vocabularyRoleActions, roleActions.items, ({ name }) => name),
  };
};

const mapDispatchToProps = {
  showDialog: showRoleActions,
};

export default connect(mapStateToProps, mapDispatchToProps)(RoleActionsContent);
